import ConfigService from "./ConfigService";
import {parse} from "../utilities/url";
import dayjs from "dayjs";

class ModuleInfoProviderClass {
    enabled = {};

    createFlatModuleArray(modules) {
        const filteredApps = [];
        modules.forEach(module => {
            filteredApps.push(module);
            if (module.modules.length) filteredApps.push(...this.createFlatModuleArray(module.modules));
        });
        return filteredApps;
    }

    getModule(key) {
        return ConfigService.modules().find(m => m.key === key);
    }

    getModuleByReference(reference) {
        const parts = (reference || '').split('/');
        return this.getModule(parts[parts.length - 1])
    }

    getModuleBaseUrl(key, urlKey) {
        const module = this.getModule(key);
        const url = parse(module.urls[urlKey]);
        url.pathname = '';
        return url.toString(null);
    }

    getModuleWebServiceUrl(key) {
        const module = this.getModule(key);
        return module.urls['ws'];
    }

    getModuleBackendUrl(key) {
        const module = this.getModule(key);
        return module.urls['backend'];
    }

    isEnabled(key) {
        if (this.enabled.hasOwnProperty(key)) return this.enabled[key];
        const module = this.getModule(key);
        if (!module) return false;
        if (!module['purchased']) return false;
        const start = dayjs(module['license']['startDate']).set('hour', 0).set('minute', 0).set('second', 0);
        const end = dayjs(module['license']['endDate']).set('hour', 23).set('minute', 59).set('second', 59);
        const now = dayjs();
        const readOnlyDeadline = now.clone().add(module['license']['readOnlyDuration'] || 0, 'day');
        const readOnly = (now.isAfter(end) && now.isBefore(readOnlyDeadline));
        const enabled = (now.isAfter(start) && now.isBefore(end)) || readOnly;
        this.enabled[key] = enabled;
        return enabled;
    }

}

const ModuleInfoProvider = new ModuleInfoProviderClass();
export default ModuleInfoProvider;



// WEBPACK FOOTER //
// ./services/ModuleInfoProvider.js